import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import { CustomerProductChangeOfAddressProcessCoverageDto } from "@/api/customer-product-change-of-address";

interface ProductChangeOfAddressState {
	id: number;
	status: string;
	changeOfAddress: {
		coverage?: CustomerProductChangeOfAddressProcessCoverageDto;
		notes: string;
		intermediateProduct: {
			salesPerson: string;
			targetDate: string;
		};
	};
	shoppingCartId?: string;
}

export const productChangeOfAddressInitialState = (): ProductChangeOfAddressState => {
	return {
		id: -1,
		status: "",
		changeOfAddress: {
			notes: "",
			intermediateProduct: {
				salesPerson: "",
				targetDate: ""
			}
		},
		shoppingCartId: undefined
	};
};

const state: ProductChangeOfAddressState = productChangeOfAddressInitialState();

export default {
	state,
	actions,
	mutations,
	getters
};
